
import { defineComponent, ref, inject, onMounted, computed, watch } from 'vue'
import { Search } from '@element-plus/icons-vue'
import { useI18n } from "vue-i18n/index";
import { useStore } from "vuex";
//services
import EventService from "@/core/services/EventService"
import { errManager } from "@/core/config/Tools";
//components
import CardEvent from "@/components/cards/Card5.vue"

export default defineComponent({
    name: "acreditation",
    components: {
        CardEvent
    },
    setup() {
        const { t } = useI18n()
        //get sharing data
        const store = useStore();
        const gblPeriodo = inject<any>('gblPeriodo')

        const loader = ref(false)
        const listEvents = ref<any>([])
        const searchText = ref('')
        const filter = ref({
            type: '',
            periodo: '',
            limit: 0,
            offset: 0
        });

        const company = computed(() => {
            return store.getters.currentUser.company
        })

        const getEventos = async () => {
            loader.value = true
            filter.value.periodo = gblPeriodo.value
            await EventService.getList(filter.value)
                .then((res) => {
                    listEvents.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    listEvents.value = []
                    errManager(response)
                }).finally(() => {
                    loader.value = false
                })
        };

        const filteredEvents = computed(() => {
            return listEvents.value.filter(
                (item) =>
                    item.name.toLowerCase().includes(searchText.value.toLowerCase())
            );
        });

        onMounted(() => {
            searchText.value = '';
            filter.value.type = '';
            filter.value.periodo = gblPeriodo.value;
            getEventos();
        });

        watch(() => gblPeriodo.value, getEventos);

        return {
            t,
            loader,
            Search,
            searchText,
            listEvents, filter, 
            //events
            company,
            getEventos, 
            filteredEvents,
        }
    }
})
